module.exports = __webpack_public_path__ + "img/img_18.ed1e83e9.jpg";